import { onMounted, onUnmounted, ref, watch, } from 'vue'
import { getActivePinia, } from 'pinia'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi.js'
import { useRoute, } from 'vue-router'

export function useIsTop () {
    let activePinia = getActivePinia()
    let appUiStore = useAppUiStore(activePinia)
    let isTop = ref(true)
    let route = useRoute()
    let onScroll = (event) => {
        isTop.value = (window.pageYOffset || event.target.scrollTop || 0) <= 100
    }
    let handleIsTop = (isTop)=>{
        if(!route.meta.landingPage) {
            appUiStore.removeTopClass('bs-app--top')

            return
        }

        isTop
            ? appUiStore.addTopClass('bs-app--top')
            : appUiStore.removeTopClass('bs-app--top')
    }

    watch(isTop, handleIsTop,{ immediate: true, })
    watch(()=>route.meta.landingPage, handleIsTop,{ immediate: true, })

    onMounted(()=> {
        window.addEventListener('scroll', onScroll)
    })

    onUnmounted(() => {
        window.removeEventListener('scroll', onScroll)
    })
}
